module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basic-page overflow-auto"
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69e68be2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Basic.vue
// module id = 2032
// module chunks = 0